import React from 'react'

const ChatConversationList = ({
  conversations,
  onSelectConversation,
  _onCreateConversation,
  loading,
  currentUser,
}) => {
  const formatTime = dateString => {
    const date = new Date(dateString)
    const now = new Date()
    const diff = now - date

    // Less than 1 minute
    if (diff < 60000) return 'Just now'

    // Less than 1 hour
    if (diff < 3600000) {
      const minutes = Math.floor(diff / 60000)
      return `${minutes}m ago`
    }

    // Less than 24 hours
    if (diff < 86400000) {
      const hours = Math.floor(diff / 3600000)
      return `${hours}h ago`
    }

    // Less than 7 days
    if (diff < 604800000) {
      const days = Math.floor(diff / 86400000)
      return `${days}d ago`
    }

    // Default to date
    return date.toLocaleDateString()
  }

  if (loading && conversations.length === 0) {
    return (
      <div className='chat-loading'>
        <div className='chat-spinner'></div>
        <p>Loading conversations...</p>
      </div>
    )
  }

  if (conversations.length === 0) {
    return (
      <div className='chat-empty'>
        <svg width='48' height='48' viewBox='0 0 24 24' fill='none'>
          <path
            d='M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H6L4 18V4H20V16Z'
            fill='#ccc'
          />
        </svg>
        <p>No conversations yet</p>
        <p className='chat-empty-subtitle'>
          {currentUser?.is_collector
            ? "Start a conversation with your account holders by selecting 'send message' from the dropdown"
            : 'Start a conversation with your collector'}
        </p>
      </div>
    )
  }

  return (
    <div className='chat-conversation-list'>
      {conversations.map(conversation => {
        const otherParticipant = conversation.attributes.other_participants[0]
        const lastMessage = conversation.attributes.last_message
        const unreadCount = conversation.attributes.unread_count

        return (
          <button
            key={conversation.id}
            className={`chat-conversation-item ${unreadCount > 0 ? 'unread' : ''}`}
            onClick={() => onSelectConversation(conversation)}
          >
            <div className='chat-conversation-avatar'>
              {otherParticipant?.display_name.charAt(0).toUpperCase()}
            </div>

            <div className='chat-conversation-content'>
              <div className='chat-conversation-header'>
                <h4>{otherParticipant?.display_name}</h4>
                {lastMessage && (
                  <span className='chat-conversation-time'>
                    {formatTime(lastMessage.created_at)}
                  </span>
                )}
              </div>

              {lastMessage && (
                <p className='chat-conversation-preview'>
                  {lastMessage.sender_name}: {lastMessage.body}
                </p>
              )}
            </div>

            {unreadCount > 0 && <span className='chat-conversation-badge'>{unreadCount}</span>}
          </button>
        )
      })}
    </div>
  )
}

export default ChatConversationList
